import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import Button from 'components/Button';
import styles from './Sales.module.scss';
import { Sales as SalesType } from 'types/sales';

interface VoidSalesModalProps {
  show: boolean;
  onHide: () => void;
  sale: SalesType | null;
  onConfirm: (reason: string) => void;
  isPending: boolean;
}

function VoidSalesModal({
  show,
  onHide,
  sale,
  onConfirm,
  isPending,
}: VoidSalesModalProps) {
  const [reason, setReason] = useState('');

  useEffect(() => {
    if (show) {
      setReason('');
    }
  }, [show]);

  if (!sale) {
    return null;
  }

  const handleConfirm = () => {
    onConfirm(reason.trim());
  };

  const formatDate = (dateString: string): string => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    }).format(date);
  };

  const formatCurrency = (amount: number): string => {
    return new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      className={styles.modal}
      contentClassName={styles.modalContent}
      dialogClassName={styles.modalDialog}
      backdrop="static"
    >
      <Modal.Header closeButton className={styles.modalHeader}>
        <Modal.Title className={styles.modalTitle}>Void Sale</Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles.modalBody}>
        <div className={styles.rollbackDetails}>
          <div className={styles.detailRow}>
            <strong>Description:</strong>
            <span>{sale.description || 'No description'}</span>
          </div>
          <div className={styles.detailRow}>
            <strong>Date:</strong>
            <span>{formatDate(sale.date)}</span>
          </div>
          <div className={styles.detailRow}>
            <strong>Total Revenue:</strong>
            <span>${formatCurrency(sale.totalRevenue)}</span>
          </div>
        </div>

        <div className={styles.formGroup}>
          <label htmlFor="voidReason" className={styles.label}>
            Reason for Voiding
          </label>
          <textarea
            id="voidReason"
            placeholder="Enter the reason for voiding this sale..."
            value={reason}
            onChange={(event) => setReason(event.target.value)}
            className={styles.textareaInput}
            rows={4}
          />
        </div>
      </Modal.Body>
      <Modal.Footer className={styles.modalFooter}>
        <Button
          type="button"
          variant="outline"
          onClick={onHide}
          disabled={isPending}
        >
          Cancel
        </Button>
        <Button type="button" onClick={handleConfirm} disabled={isPending}>
          {isPending ? 'Voiding...' : 'Void Sale'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default VoidSalesModal;
